import { render, staticRenderFns } from "./NewAppointment.vue?vue&type=template&id=2917d568&scoped=true&"
import script from "./NewAppointment.vue?vue&type=script&lang=js&"
export * from "./NewAppointment.vue?vue&type=script&lang=js&"
import style0 from "./NewAppointment.vue?vue&type=style&index=0&id=2917d568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2917d568",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VWindow } from 'vuetify/lib'
import { VWindowItem } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCheckbox,VContainer,VDatePicker,VDialog,VForm,VList,VListTile,VListTileAction,VListTileContent,VListTileTitle,VSelect,VSpacer,VTextField,VTextarea,VWindow,VWindowItem})
